import {useHistory,useParams} from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import Grid from "@mui/material/Grid";
import { ButtonGroup, Paper, Link } from "@mui/material";
import {TextItem} from "../../components/TextItem";
import Button from "@mui/material/Button";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MapSession from "../../components/mapview/MapSession";
import {get,getErrorMessage,put,SESSIONS,USERS} from "../../services/Client";
import React,{useEffect, useState} from "react";
import RenderCell from "../../components/cellRender/RenderCell";
import RenderBoolean from "../../components/cellRender/RenderBoolean";
import NTMXGrid,{numberFormatter,timestampFormatter} from "../../components/NTMXGrid";
import StartIconButton from "../../components/buttons/StartIconButton";
import ReplayIcon from '@mui/icons-material/Replay';
import PartialModal from "../../components/modals/PartialModal";
import {useSnackbar} from "notistack";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {useGetSessionInfo} from "../../services/ContentManager";
import dayjs from "dayjs";
import {partialType,useGetPartialTypeName} from "../../constants/partialType";
import FilterListIcon from "@mui/icons-material/FilterList";
import ListIcon from "@mui/icons-material/List";
import RoomIcon from '@mui/icons-material/Room';
import EditRoad from '@mui/icons-material/EditRoad';

import refundStatus from "../../constants/refundStatus";
import {useTranslation} from "react-i18next";
import useGetRefundStatus from "../../constants/refundStatus";
import {Helmet} from "react-helmet";
import {useQueryClient} from "react-query";
import {Visibility,VisibilityOff} from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
    page: {
        padding: theme.spacing(2)
    },
    container: {
        marginBottom: theme.spacing(2)
    },
    mapContainer: {
        width: "100%",
        height: "60vh",
    },
    box: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        borderBottom: `${theme.palette.secondary.main} 1px solid`,
        color: theme.palette.primary.dark,
        fontWeight: "bold",
        flexGrow: 1,
    },
    backButton: {
        color: theme.palette.primary.main,
    },
    backButtonIcon: {
        margin: theme.spacing(1)
    },
    button: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
    }
}));

export default function SessionInfo(){

    let classes = useStyles();
    let {id} = useParams();
    let history = useHistory();
    const {t} = useTranslation();
    let {session, status} = useGetSessionInfo(id)
    let [values, setValues] = useState();
    let [homePoints, setHomePoints] = useState();
    let [workPoints, setWorkPoints] = useState();
    let [username, setUsername] = useState();
    let [isChangingParameters, setIsChangingParameters] = useState(false);
    let [polylineType, setPolylineType] = useState("polyline");
    let [showDebug, setShowDebug] = useState(false);
    let [isShowingPartialPoints, setIsShowingPartialPoints] = useState(true);
    let [isCalculatingPath, setIsCalculatingPath] = useState(false)
    const {enqueueSnackbar} = useSnackbar();
    const partialTypeName = useGetPartialTypeName();
    const refundStatus = useGetRefundStatus()
    const queryClient = useQueryClient()
    let [isShowingOrganizationArea, setIsShowingOrganizationArea] = useState(false)

    const partialStatus = [
        {
            id: 0,
            name: t('valid')
        },
        {
            id: 1,
            name: t('generalError')
        },
        {
            id: 2,
            name: t('inaccurateDistance')
        },
        {
            id: 3,
            name: t('invalidAverageSpeed')
        },
        {
            id: 7,
            name: t('speedPeakDetected')
        },
        {
            id: 8,
            name: t('certificated')
        }
    ]

    const defaultColumns = [
        {
            headerName: t('time'),
            field: 'timestamp',
            width: 240,
            ...timestampFormatter
        },
        {
            headerName: t('latitude'),
            field: 'latitude',
            width: 280,
            type: "number",
            headerAlign: 'left',
            align: "left",
            renderCell: (params) => <RenderCell params = {params} measureUnit="°"/>,
            //hide: true,
        },
        {
            headerName: t('longitude'),
            field: 'longitude',
            width: 280,
            type: "number",
            headerAlign: 'left',
            align: "left",
            renderCell: (params) => <RenderCell params = {params} measureUnit="°"/>,
            //hide: true,
        },
        {
            headerName: t('altitude'),
            field: 'altitude',
            width: 280,
            type: "number",
            headerAlign: 'left',
            align: "left",
            renderCell: (params) => <RenderCell params = {params} measureUnit="°"/>,
            //hide: true,
        },
        {
            headerName: t('sensorDistance'),
            field: 'sensorDistance',
            width: 170,
            renderCell: (params) => <RenderCell params = {params} measureUnit="km" type="number" decimals={4}/>,
            ...numberFormatter
        },
        {
            headerName: t('gpsDistance'),
            field: 'gpsDistance',
            width: 170,
            renderCell: (params) => <RenderCell params = {params} measureUnit="km" type="number" decimals={4}/>,
            ...numberFormatter
        },
        {
            headerName: t('googleMapsDistance'),
            field: 'gmapsDistance',
            width: 170,
            renderCell: (params) => <RenderCell params = {params} measureUnit="km" type="number" decimals={4}/>,
            ...numberFormatter
            //hide: true,
        },
        {
            headerName: t('deltaRevolutions'),
            field: 'deltaRevs',
            width: 160,
            renderCell: (params) => <RenderCell params = {params} type="number"/>,
            ...numberFormatter
            //hide: true,
        },
        {
            headerName: t('urban'),
            field: 'urban',
            width: 150,
            renderCell: (params) => <RenderBoolean params={params}/>,
            //hide: true,
        },
        {
            headerName: t('valid'),
            field: 'valid',
            width: 150,
            renderCell: (params) => <RenderBoolean params={params}/>
        },
        {
            headerName: t('type'),
            field: 'type',
            width: 280,
            valueGetter: (params) => partialTypeName[params.value]

        },
        {
            headerName: t('status'),
            field: 'status',
            width: 280,
            valueGetter: (params) => params.value !== undefined && partialStatus.find(s => s.id === params.value).name,
        },
        {
            headerName: t('extra'),
            field: 'extra',
            width: 280,
            //hide: true
        }
    ];

    const getFilteredPartials = () => {
        if(session && session.partials) {
            if(showDebug) return(session.partials)
            else return(session.partials.filter(p => (p.type < partialType.SESSION)))
        }
    }

    useEffect(() => {
        if(session) session.sessionPoints = session.sessionPoints || []
        setValues(session)
        session && get(`users/${session.uid}/home-addresses`, {params: {activeAt: session.endTime}}).then(r => {
            let newValues = [];
            r.map(ha => newValues.push({lat: ha.latitude, lng: ha.longitude, tolerance: ha.tolerance*1000, organization: ha.organizationName}))
            setHomePoints(newValues)
        })
        session && get(`users/${session.uid}/work-addresses`, {params: {activeAt: session.endTime}}).then(r => {
            let newValues = [];
            r.map(wa => newValues.push({lat: wa.latitude, lng: wa.longitude, tolerance: wa.tolerance*1000}))
            setWorkPoints(newValues)
        })
        session && get(USERS ,{elem: session.uid}).then(u => setUsername(u.username))
    }, [session])

    let gyroDistance = values && values.gyroDistance ? values.gyroDistance + " Km" : "";
    let gpsDistance = values && values.gpsDistance ? values.gpsDistance + " Km" : "";
    let gmapsDistance = values && values.gmapsDistance ? values.gmapsDistance + " Km" : "";

    const reloadPartials = (parameters) => {
        let newParameters = {...parameters}
        newParameters.partialQty = parameters.partialQty /100;
        newParameters.partialDeviation = parameters.partialDeviation /100;
        enqueueSnackbar(t('reloading...'), {variant: "info"});
        put(SESSIONS, {params: newParameters, elem: id+"/validate"})
            .then(({data}) => {
                setValues(data);
                enqueueSnackbar(t('saved'), {variant: "success"});
            })
            .catch(e => enqueueSnackbar(getErrorMessage(e), {variant: "error"}))
    }

    const calculatePath = () => {
        setIsCalculatingPath(true)
        get(`${SESSIONS}/${id}/here-path`)
            .then(()=>queryClient.invalidateQueries([SESSIONS, {id}]))
            .catch(e =>enqueueSnackbar(getErrorMessage(e), {variant: 'error'}))
            .finally(() => {
                setIsCalculatingPath(false)
            });
    }

    const getDateWithTimezone = (timestamp, timezone) => {
        const date = dayjs.tz(new Date(timestamp), timezone).format("HH:mm:ss DD/MM/YYYY")
        if(timezone) return `${date}  (${timezone})`
        else return date
    }

    return (
        <Paper className={classes.page}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Dettaglio Sessione | Pin Bike</title>
                <meta name="description" content="Dettaglio sessione effettuata tramite app Pin Bike" />
            </Helmet>

        <Grid container justifyContent="space-between">
            <Grid item>
                <Button onClick={() => history.replace("/sessions")} className={classes.backButton}>
                    <ArrowBackIcon className={classes.backButtonIcon}/>
                    {t('goBack')}
                </Button>
            </Grid>
            <Grid item>
                <StartIconButton title={t('changeParameters')} onClick={() => setIsChangingParameters(true)} startIcon={<ReplayIcon/>}/>
            </Grid>
        </Grid>

        <Grid container alignItems={"flex-end"} className={classes.container}>
            <TextItem value={values && values.id} label={t('sessionID')}/>
            <TextItem value={values && <Link href={"/profile/" + values.uid} target="_blank" underline='none'>{username}</Link>} label={t('username')}/>
            <TextItem value={values && getDateWithTimezone(values.startTime, values.timezone)} label={t('startDate')}/>
            <TextItem value={values && getDateWithTimezone(values.endTime, values.timezone)} label={t('endDate')}/>
            <TextItem value={gyroDistance} label={t('gyroDistance')}/>
            <TextItem value={gpsDistance} label={t('gpsDistance')}/>
            <TextItem value={gmapsDistance} label={t('googleMapsDistance')}/>
            <TextItem value={values && <FiberManualRecordIcon style={{color: values.valid ? "#43ff00" : "#ff0000"}}/>} label={t('valid')}/>
            <TextItem value={values && <FiberManualRecordIcon style={{color: values.homeWorkPath ? "#43ff00" : "#ff0000"}}/>} label={t('homeWorkSchoolPath')}/>
            <TextItem value={values && <FiberManualRecordIcon style={{color: values.certificated ? "#43ff00" : "#ff0000"}}/>} label={t('certificated')}/>
        </Grid>
        <Grid container alignItems={"center"} className={classes.container}>
        {
            values && values.sessionPoints && values.sessionPoints.map(sp => <>
                <Grid item xs={12} md={3} style={{display: "flex"}}>
                    <TextItem value={`${(sp.distance || 0).toFixed(2)} km`} label={`${t('distance')} - ${sp.organizationTitle}`}/>
                </Grid>
                <Grid item xs={12} md={3} style={{display: "flex"}}>
                    <TextItem value={(sp.points || 0).toFixed(2)} label={`${t('points')} - ${sp.organizationTitle}`}/>
                </Grid>
                <Grid item xs={12} md={3} style={{display: "flex"}}>
                    <TextItem value={`${(sp.euro || 0).toFixed(2)} €`} label={`${t('euro')} - ${sp.organizationTitle}`}/>
                </Grid>
                <Grid item xs={12} md={3} style={{display: "flex"}}>
                    <TextItem value={refundStatus.find(rs => rs.id === sp.refundStatus) ? refundStatus.find(rs => rs.id === sp.refundStatus).name : "-"} label={t('refundStatus')}/>
                </Grid>
            </>)
        }
        </Grid>

        <Grid container justifyContent="center">
            {values && values.partials &&
                <Grid container md={4} justifyContent={"center"}>
                    <StartIconButton title={isShowingPartialPoints ? t('hidePartials') : t('showPartials')}
                                     onClick={() => setIsShowingPartialPoints(old => !old)}
                                     startIcon={<RoomIcon/>}/>
                </Grid>
            }

            {session && session.sessionPoints && session.sessionPoints.length > 0 &&
                <Grid container md={4} justifyContent={"center"}>
                    <StartIconButton title={isShowingOrganizationArea ? t('hideInitiativeArea') : t('showInitiativeArea')}
                                     onClick={() => setIsShowingOrganizationArea(prevState => !prevState)}
                                     startIcon={isShowingOrganizationArea ? <VisibilityOff/> : <Visibility/>}/>
                </Grid>
            }

            <Grid container md={4} justifyContent={"center"}>
                <StartIconButton title={t('esteemRouteByRoad')} onClick={calculatePath}
                                 startIcon={<EditRoad/>} disabled={isCalculatingPath}/>
            </Grid>

            <Grid container md={8} justifyContent={"center"}>
                <ButtonGroup color="secondary" aria-label="outlined secondary button group" className={classes.button}>
                    <Button variant="outlined" color={polylineType === "polyline" ? "secondary" : "primary"}
                            onClick={() => setPolylineType("polyline")}>
                        {t('pathViewedByUser')}
                    </Button>
                    <Button variant="outlined" color={polylineType === "rawPolyline" ? "secondary" : "primary"}
                            onClick={() => setPolylineType("rawPolyline")}>
                        {t('directConnection')}
                    </Button>
                    <Button variant="outlined" color={polylineType === "gmapsPolyline" ? "secondary" : "primary"}
                            onClick={() => setPolylineType("gmapsPolyline")}>
                        {t('googleMapsPath')}
                    </Button>
                </ButtonGroup>
            </Grid>
        </Grid>

            <Grid container className={classes.mapContainer}>
                {
                    values &&
                    <MapSession polylines={{polyline: values.polyline, rowPolyline: values.rowPolyline, gmapsPolyline: values.gmapsPolyline}}
                                zoom={15} points={(values.partials || []).filter(p => p.type < partialType.SESSION || p.type === partialType.SKIPPED)}
                                polylineType={polylineType} isShowingPartialPoints={isShowingPartialPoints}
                                homePoints={homePoints} workPoints={workPoints}
                                sessionPointsForArea={isShowingOrganizationArea ? session.sessionPoints : []}
                    />
                }
            </Grid>

        {session && session.partials &&
            <NTMXGrid
                key={"session-partials-table"}
                columns={defaultColumns}
                rows={getFilteredPartials()}
                title={t('partials')}
                loading={status === "loading"}
                getRowId={(row) => row.timestamp}
                rightButton={<Grid container justifyContent={"flex-end"}>
                    <StartIconButton
                        onClick={() => setShowDebug(!showDebug)}
                        title={showDebug ? t('hideDebug') : t('showDebug')}
                        startIcon={showDebug ? <FilterListIcon/> : <ListIcon/>}/>
                </Grid>}
            />
        }

            <PartialModal open={!!isChangingParameters} onClose={() => setIsChangingParameters(false)} onSubmit={reloadPartials}/>

        </Paper>
    );
}
